export default "__VITE_ASSET__b05a6d70__"